import { useRef, useEffect, useState } from "react";
import "./Recommendation.css";
import img1 from "../../assets/whyus_proven_systems.png";
import img2 from "../../assets/whyus_qualified_installers.png";
import img3 from "../../assets/whyus_tailored.png";
import img4 from "../../assets/whyus_handle_everything.png";
import savesUnderline from "../../assets/figma_saves_underline.svg";

const reasons = [
  {
    number: "01",
    img: img1,
    title: "Proven Systems You Can Rely On",
    desc: "Trusted brands proven in Australian conditions — built for long-term reliability and real savings.",
  },
  {
    number: "02",
    img: img2,
    title: "Carefully Selected, Qualified Installers",
    desc: "Fully qualified electricians only, so your system is installed properly from day one.",
  },
  {
    number: "03",
    img: img3,
    title: "Tailored to Your Home, Not a Sales Pitch",
    desc: "Designed around your actual energy usage — no upselling, no one-size-fits-all packages.",
  },
  {
    number: "04",
    img: img4,
    title: "We Handle Everything, Start to Finish",
    desc: "Consultation, installation, ongoing support — we take care of the whole process for you.",
  },
];

export default function Recommendation() {
  const sectionRef = useRef(null);
  const leftRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { threshold: 0.1 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const section = sectionRef.current;
      const left = leftRef.current;
      if (!section || !left) return;
      const rect = section.getBoundingClientRect();
      // How far the section has scrolled past the viewport top
      const navH = 90; // fixed navbar height
      const scrolled = Math.max(0, navH - rect.top);
      const parallax = Math.min(scrolled * 0.6, 240);
      left.style.transform = `translateY(${parallax}px)`;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section ref={sectionRef} className={`rec-section ${inView ? "rec-in-view" : ""}`}>
      <div className="rec-inner">

        {/* Left — text only, parallax */}
        <div className="rec-left" ref={leftRef}>
          <span className="rec-label">Why Choose Us</span>
          <h2 className="rec-title">
            The honest way<br />
            to go{" "}
            <span className="rec-solar-accent">
              solar
              <img src={savesUnderline} alt="" className="rec-solar-stroke" />
            </span>
          </h2>
          <p className="rec-subtitle">
            We focus on long-term reliability, quality installation, and solutions that make sense for Melbourne homes.
          </p>
          <div className="rec-accent-bar" />
          <div className="rec-stat-pill">
            <span className="rec-stat-num">Hundreds</span>
            <span className="rec-stat-label">Melbourne homes powered</span>
          </div>
        </div>

        {/* Right — 2×2 photo cards */}
        <div className="rec-right">
          {reasons.map((r, i) => (
            <div className="rec-card" key={i}>
              <div className="rec-card-img-wrap">
                <img src={r.img} alt="" className="rec-card-img" />
                <span className="rec-num">{r.number}</span>
              </div>
              <div className="rec-card-body">
                <h3 className="rec-card-title">{r.title}</h3>
                <p className="rec-card-desc">{r.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
